@if (list) {
  @if (!isLargelist) {
    <mat-form-field>
      <mat-label>{{ fieldLabel }}</mat-label>
      <mat-select
        #select
        [formControl]="control()"
        [appMultiValueHotkeys]="mvFieldMenu()"
        [compareWith]="selectedValueIsInList"
        [panelClass]="matSelectPanelClass()"
        typeaheadDebounceInterval="1000"
        (focus)="onFocus()"
        (blur)="onBlur($event)"
        (selectionChange)="onSelectionChange()"
        (opened)="onSelectOpen()"
        (closed)="onSelectClosed()"
      >
        <mat-option></mat-option>
        @for (value of list.values; track value) {
          <mat-option
            [matTooltipDisabled]="value.length <= 16"
            matTooltipShowDelay="1000"
            [matTooltip]="value"
            [value]="value"
            >{{ value }}</mat-option
          >
        }
      </mat-select>
      @if (field().multiValue && mvFieldMenu()) {
        <button
          [disabled]="control().disabled"
          tabIndex="-1"
          mat-icon-button
          type="button"
          matSuffix
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="mvFieldMenu()!.matMenu"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      }
      @if (control().invalid) {
        <mat-error class="ellipsis" [matTooltip]="errorMessage"
          >{{ errorMessage }}
        </mat-error>
      }
    </mat-form-field>
  } @else {
    <mat-form-field>
      <mat-label>{{ fieldLabel }}</mat-label>
      <input
        #input
        type="text"
        matInput
        [formControl]="control()"
        [matAutocomplete]="auto"
        [appMultiValueHotkeys]="mvFieldMenu()"
        (focus)="onFocus()"
        (blur)="onBlur($event)"
        (keydown.escape)="onEscapeTypeaheadInput($event)"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [class]="`${matSelectPanelClass()}`"
        (optionSelected)="onSelectionChange()"
        (optionActivated)="onActivateTypeaheadListItem($event)"
      >
        @for (option of filteredValues$ | async; track option) {
          <mat-option
            [value]="option"
            [matTooltipDisabled]="option.length <= 16"
            matTooltipShowDelay="1000"
            [matTooltip]="option"
          >
            {{ option }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (field().multiValue && mvFieldMenu()) {
        <button
          [disabled]="control().disabled"
          tabIndex="-1"
          mat-icon-button
          type="button"
          matSuffix
          [matMenuTriggerFor]="mvFieldMenu()!.matMenu"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      }
      @if (control().invalid) {
        <mat-error class="ellipsis" [matTooltip]="errorMessage"
          >{{ errorMessage }}
        </mat-error>
      }
    </mat-form-field>
  }
} @else {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
